import {RouterProvider} from "react-router-dom";
import {QueryClientProvider} from "@tanstack/react-query";
import {TranslationProvider as ComponentsTranslationProvider} from "@crunchyroll/cx-web-components";

import queryClient from "./queryClient";
import {LocalizationProvider} from "./features/localization/components/localizationProvider";
import getRouter from "./router";
import {LegacyRedirect} from "./features/legacyRedirects/components/legacyRedirect";

const Root = () => (
  <>
    <QueryClientProvider client={queryClient}>
      <LocalizationProvider>
        {({messages}) => (
          <ComponentsTranslationProvider value={messages}>
            <RouterProvider router={getRouter()} />
          </ComponentsTranslationProvider>
        )}
      </LocalizationProvider>
    </QueryClientProvider>
    <LegacyRedirect />
  </>
);

export default Root;
